import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppSelector } from '../../store/hooks';
import routes from '../../utils/routes';
import strings from '../../utils/strings';
import { CButton, CText } from '../../components/common';

const Connect: React.FC = () => {
  const navigate = useNavigate();
  const colors = useAppSelector((state) => state.theme.theme);

  return (
    <div
      className="flex flex-col items-center min-h-screen"
      style={{ backgroundColor: colors.backgroundColor }}
    >
      {/* Hero Image */}
      <div
        className="w-full h-48 md:h-64 flex items-center justify-center"
        style={{ backgroundColor: colors.inputBackground }}
      >
        <span className="text-6xl" style={{ color: colors.primary }}>💼</span>
      </div>

      {/* Content */}
      <div className="w-full max-w-md px-5 py-6">
        <CText type="B24" align="center">
          {strings.getStarted}
        </CText>
        <CText type="R14" color={colors.grayScale500} align="center" style={{ marginTop: '4px' }}>
          All-in-One Investment Platform
        </CText>

        <div className="mt-6">
          <CButton
            title={strings.continueWithPhoneNumber}
            onPress={() => navigate(routes.login)}
            type="B16"
          />
        </div>

        <button
          className="w-full h-12 rounded-xl border flex items-center justify-center cursor-pointer mt-3 bg-transparent hover:opacity-80 transition-opacity"
          style={{ borderColor: colors.grayScale200 }}
          onClick={() => {/* Implement FB Auth */}}
        >
          <CText type="S16" color={colors.textColor}>
            {strings.continueWithFB}
          </CText>
        </button>

        <button
          className="w-full h-12 rounded-xl border flex items-center justify-center cursor-pointer mt-3 bg-transparent hover:opacity-80 transition-opacity"
          style={{ borderColor: colors.grayScale200 }}
          onClick={() => {/* Implement Google Auth */}}
        >
          <CText type="S16" color={colors.textColor}>
            {strings.continueWithGoogle}
          </CText>
        </button>

        <div className="flex justify-center mt-6 mb-4">
          <CText type="R14" color={colors.grayScale500}>
            {strings.doHaveAnAccount}
          </CText>
          <span
            className="ml-1 cursor-pointer"
            style={{ color: colors.primary }}
            onClick={() => navigate(routes.signUp)}
          >
            <CText type="R14" color={colors.primary}>
              {strings.signUp}
            </CText>
          </span>
        </div>
      </div>
    </div>
  );
};

export default Connect;
